module.exports = __webpack_public_path__ + "img/image-31.d95c08d9.jpg";